<template>
<div class='grid-wrap'>
  <dx-data-grid ref='refCompanyGrid'
    :data-source='dataSource'
    :show-borders = 'true' :showRowLines = 'false' :showColumnLines='true'
    :hover-state-enabled = "true" :allowColumnResizing = 'true'
    column-resizing-mode = 'widget' :allow-column-reordering = "true"
    :height="gridHeight" :row-alternation-enabled="true"
    keyExpr="seqId" :focusedRowEnabled="true"
    @toolbarPreparing="onToolbarPreparing"
    @rowDblClick ='onRowDbClick'
  >
    <DxSearchPanel
      :visible="true"
      placeholder="검색..."
    />
    <DxFilterRow
      :visible="false"
      apply-filter="auto"
    />
    <DxColumnFixing :enabled="true"/>
    <DxColumn
    :allowEditing="false"
    :visible="true"
    caption="고객사"
    data-field="고객사명"
    alignment="center"
    :min-width="140"
    :fixed="true"
    >
    </DxColumn>
    <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="포지션제목"
      data-field="포지션제목"
      alignment="left"
      :min-width="300"
      :fixed="true"
      >
    </DxColumn>
    <DxColumn
      caption="포지션정보"
    >
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="채용직급"
      data-field="채용직급"
      alignment="center"
      :min-width="100"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="담당컨설턴트"
      data-field="컨설턴트"
      alignment="center"
      :min-width="100"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="추천인"
      data-field="추천인"
      alignment="center"
      :min-width="100"
      >
      </DxColumn>
    </DxColumn>
    <DxColumn
      caption="후보자 정보"
    >
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="성명"
      data-field="성명"
      alignment="center"
      :min-width="100"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="성별"
      data-field="성별"
      alignment="center"
      :min-width="80"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="나이"
      :calculate-cell-value="calculateAge"
      alignment="center"
      :min-width="80"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="최종학교명"
      data-field="최종학교명"
      alignment="left"
      :min-width="150"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="추천진행단계"
      data-field="추천진행단계"
      alignment="center"
      :min-width="100"
      >
      </DxColumn>
      <DxColumn
      :allowEditing="true"
      :visible="true"
      caption="등록일"
      data-field="createdTime"
      alignment="center"
      format="yyyy-MM-dd"
      dataType="date"
      :min-width="80"
      >
      </DxColumn>
    </DxColumn>
      <dx-paging :enabled="false"/>
      <dx-scrolling mode="standard" showScrollbar='always' :useNative='false'/>
      <dx-sorting mode="single"/>
    <dx-paging :enabled="false"/>
    <dx-scrolling mode="virtual" showScrollbar='always' :useNative='false'/>
    <dx-sorting mode="multiple"/>
  </dx-data-grid>
</div>
</template>

<script>
import ConstDef from '../../share/ConstDef'
import DxDataGrid, { DxScrolling, DxFilterRow, DxColumnFixing,
  DxColumn, DxPaging, DxSorting, DxSearchPanel
} from 'devextreme-vue/data-grid'

export default {
  name: 'customerSummartComponent',
  data: function () {
    return {
      dataSource: null,
      isExporing: false,
      gridHeight: null,
      studyLookup: this.$store.getters.getBaseDataByType(ConstDef.최종학력),
      manWoomanLookup: ConstDef.남녀,
      graduateLookup: ConstDef.졸업여부,
      levelLookup: ConstDef.상중하,
      profileSourceLookup: this.$store.getters.getBaseDataByType(ConstDef.프로필입수경로),
      languageLookup: this.$store.getters.getBaseDataByType(ConstDef.외국어능력),
      liveLookup: this.$store.getters.getBaseDataByType(ConstDef.주거조건),
      employeeInfo: this.$store.getters.getEmployee,
      재직여부Lookup: ConstDef.재직여부Lookup
    }
  },
  components: {
    DxDataGrid,
    DxScrolling,
    DxFilterRow,
    DxColumnFixing,
    DxColumn,
    DxPaging,
    DxSorting,
    DxSearchPanel
  },
  created () {
    document.title = ConstDef.WEB_TAB_TITLE
    this.userInfo = this.$store.getters.getUserInfo
    if (this.userInfo === null) {
      this.$router.push('/')
    }
    this.refreshDataSource()
  },
  mounted () {
    this.gridHeight = (screen.height - 260) / 3
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    calculateAge (row) {
      if (row.생년월일 !== undefined) {
        return parseInt(this.$_appLib.getToday().substring(0, 4)) - parseInt(row.생년월일.substring(0, 4))
      }
    },
    onRowDbClick (e) {
      console.log(e.data)
      this.$router.push(`/main/applicantSearch?seqId=${e.data.지원자코드}`)
    },
    onToolbarPreparing (e) {
      e.toolbarOptions.items.unshift(
        {
          location: 'before',
          template: function () {
            return `<div class="toolbar-label" style='margin-left:4px;'><b><span style="color:black;font-size:1.2rem;">&#10016;</span> 포지션별 지원 정보</b></div>`
          }
        }
      )
    },
    refreshDataSource () {
      this.$_sp.runFindProc('spFindAllPositionAndApplicant', null)
        .then(data => {
          this.dataSource = this.$_sp.MakeModel(data)
        })
        .catch(error => {
          if (error.response.status === ConstDef.GENERRAL_ERROR) {
            this.$snotify.error(error.response.data.message)
          } else {
            this.$snotify.error(`에러코드 : ${error.response.status}`)
          }
        })
    }
  }
}
</script>

<style lang="scss">

</style>
